import React from 'react';
import { useRecoilState } from 'recoil';
import { cartState } from '../atoms/cartAtom';
import { motion, AnimatePresence } from 'framer-motion';

const CartIcon = () => {
  const [cart, setCart] = useRecoilState(cartState);
  
  const handleToggleCart = () => {
    setCart(prev => ({
      ...prev,
      isOpen: !prev.isOpen
    }));
  };
  
  return (
    <div className="relative">
      <button
        onClick={handleToggleCart}
        className="p-2 rounded-full text-gray-600 hover:text-[#174540] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#83c5be] transition-all duration-300"
        aria-label="Panier"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
        
        <AnimatePresence>
          {cart.count > 0 && (
            <motion.div
              key="badge"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              className="absolute -top-1 -right-1 bg-[#174540] text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center"
            >
              {cart.count}
            </motion.div>
          )}
        </AnimatePresence>
      </button>
    </div>
  );
};

export default CartIcon;